(function () {
  var CM_PER_IN = 2.54;
  var MM_PER_IN = 25.4;
  var UNIT_BUTTONS = '#js-btn-cm, #js-btn-in, #js-btn-metric, #js-btn-imperial';

  function roundTo(x, decimals) {
    if (!decimals) return Math.round(x);
    var factor = Math.pow(10, decimals);
    return Math.round(x * factor) / factor;
  }

  function formatIn(x, decimals) {
    var n = roundTo(x, decimals);
    return decimals ? n.toFixed(decimals) : String(n);
  }

  function parseNum(s) {
    var t = String(s || '').trim().replace(',', '.');
    var v = parseFloat(t);
    return isFinite(v) ? v : null;
  }

  function rangeToInText(range, perIn, decimals) {
    var t = String(range || '').trim();
    t = t.replace(/\s*[-–]\s*/g, '-');
    var parts = t.split('-');

    function one(part) {
      var value = parseNum(part);
      return value === null ? String(part).trim() : formatIn(value / perIn, decimals);
    }

    if (parts.length === 1) return one(parts[0]);
    if (parts.length === 2) return one(parts[0]) + ' - ' + one(parts[1]);
    return t;
  }

  function chartRootFrom(el) {
    if (el && el.closest) {
      var root = el.closest('.size-chart-modal-info') || el.closest('.page-with-nav__rte') || el.closest('.rte');
      if (root) return root;
    }
    return getChartRoot();
  }

  function getChartRoot() {
    var modal = document.querySelector('.size-chart-modal-info');
    if (modal && modal.querySelector('#js-btn-cm, #js-btn-metric')) return modal;

    var btn = document.querySelector('#js-btn-cm, #js-btn-metric');
    if (btn) {
      return (
        (btn.closest && (btn.closest('.page-with-nav__rte') || btn.closest('.rte') || btn.closest('.size-chart-modal-info'))) ||
        btn.parentElement ||
        document.body
      );
    }

    return modal || document.body;
  }

  function clearOnclick(btn) {
    if (!btn) return;
    btn.removeAttribute('onclick');
    btn.onclick = null;
  }

  function queryUnitButton(container, ids) {
    for (var i = 0; i < ids.length; i++) {
      var btn = container.querySelector('#' + ids[i]);
      if (btn) return btn;
    }
    return null;
  }

  function usesDecimalInches(container) {
    return !!(
      container.querySelector &&
      (container.querySelector('#js-btn-metric') || container.querySelector('[data-mm]') || container.querySelector('.js-mm'))
    );
  }

  function setSpanDisplay(nodes, show) {
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.display = show ? '' : 'none';
    }
  }

  function setUnit(unit, root) {
    var isCm = unit === 'cm';
    var container = root || getChartRoot();
    var btnCm = queryUnitButton(container, ['js-btn-cm', 'js-btn-metric']);
    var btnIn = queryUnitButton(container, ['js-btn-in', 'js-btn-imperial']);
    var label = container.querySelector('#js-unit-label');
    var decimals = usesDecimalInches(container) ? 1 : 0;

    clearOnclick(btnCm);
    clearOnclick(btnIn);

    if (btnCm && btnIn) {
      btnCm.style.background = isCm ? '#111' : '#fff';
      btnCm.style.color = isCm ? '#fff' : '#111';
      btnIn.style.background = isCm ? '#fff' : '#111';
      btnIn.style.color = isCm ? '#111' : '#fff';
    }

    if (label) {
      label.textContent = isCm ? '(cm)' : '(in)';
    }

    var unitValue = isCm ? 'cm' : 'in';
    if (container.setAttribute) {
      container.setAttribute('data-unit', unitValue);
    }

    setSpanDisplay(container.querySelectorAll('span[data-unit="cm"], span[data-unit="mm"]'), isCm);
    setSpanDisplay(container.querySelectorAll('span[data-unit="in"], span[data-unit="in2"]'), !isCm);

    var cells = container.querySelectorAll('table td[data-cm]');
    if (cells.length === 0) {
      cells = container.querySelectorAll('.js-cmrange');
    }
    if (cells.length === 0) {
      cells = container.querySelectorAll('table td:not([data-mm]):not(.js-mm)');
    }
    for (var i = 0; i < cells.length; i++) {
      var td = cells[i];
      if (td.hasAttribute('data-mm') || (td.classList && td.classList.contains('js-mm'))) continue;

      var cm = td.getAttribute('data-cm');
      if (cm == null || cm === '') {
        var text = (td.textContent || '').trim();
        var isInches = /\s*in\s*$/i.test(text);
        var rangeMatch = text.match(/^([\d,.]+)\s*[-–]\s*([\d,.]+)\s*(?:cm|in)?$/i);
        var singleMatch = text.match(/^([\d,.]+)\s*(?:cm|in)?$/i);
        if (rangeMatch) {
          var r1 = parseNum(rangeMatch[1]);
          var r2 = parseNum(rangeMatch[2]);
          if (isInches && r1 !== null && r2 !== null) {
            cm = String(roundTo(r1 * CM_PER_IN, decimals)) + '-' + String(roundTo(r2 * CM_PER_IN, decimals));
          } else {
            cm = rangeMatch[1].replace(',', '.') + '-' + rangeMatch[2].replace(',', '.');
          }
          td.setAttribute('data-cm', cm);
        } else if (singleMatch) {
          var val = parseNum(singleMatch[1]);
          if (val !== null && isInches) {
            cm = String(roundTo(val * CM_PER_IN, decimals));
          } else {
            cm = singleMatch[1].replace(',', '.');
          }
          td.setAttribute('data-cm', cm);
        } else {
          continue;
        }
      }

      var hasUnitSpans = td.querySelector && (td.querySelector('span[data-unit="cm"]') || td.querySelector('span[data-unit="in"]'));
      if (!hasUnitSpans) {
        td.textContent = isCm ? cm : rangeToInText(cm, CM_PER_IN, decimals);
      }
      td.setAttribute('data-unit', unitValue);
    }

    var mmCells = container.querySelectorAll('td[data-mm], td.js-mm');
    for (var m = 0; m < mmCells.length; m++) {
      var mmCell = mmCells[m];
      var mm = mmCell.getAttribute('data-mm');
      if (mm == null || mm === '') {
        mm = (mmCell.textContent || '').trim();
        if (!mm) continue;
        mmCell.setAttribute('data-mm', mm);
      }
      var mmHasSpans = mmCell.querySelector && mmCell.querySelector('span[data-unit]');
      if (!mmHasSpans) {
        mmCell.textContent = isCm ? mm : rangeToInText(mm, MM_PER_IN, decimals);
      }
      mmCell.setAttribute('data-unit', unitValue);
    }
  }

  window.__setUnit = setUnit;

  function initSizeChart() {
    var buttons = document.querySelectorAll(UNIT_BUTTONS);
    for (var i = 0; i < buttons.length; i++) clearOnclick(buttons[i]);
    setUnit('cm', getChartRoot());
  }

  window.__initSizeChart = initSizeChart;

  if (!window.__sizeChartClickBound) {
    window.__sizeChartClickBound = true;
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var btn = target.closest(UNIT_BUTTONS);
      if (!btn) return;
      clearOnclick(btn);
      event.preventDefault();
      var unit = btn.id === 'js-btn-in' || btn.id === 'js-btn-imperial' ? 'in' : 'cm';
      setUnit(unit, chartRootFrom(btn));
    }, true);
  }

  document.addEventListener('DOMContentLoaded', initSizeChart);
})();
